import moment from "moment";
import { pick, lensProp, over, reverse } from "ramda";
export const recommendedTitle = "Show insiders recommended for me";

export const getInsiderAvailability = slots =>
  slots.map(({ id, time_start }) => ({
    id,
    time: formatTime(time_start)
  }));

export const mergeSlots = (current, next) =>
  over(lensProp("results"), results => [...current.results, ...results], next);

export const formatTime = time =>
  moment(time).format("ddd, MMM Do, YYYY - h:mm A");

export const getReviews = reviews =>
  reverse(
    reviews.filter(r => r.shared).map(r => ({
      text: r.general_feedback,
      date: moment(r.created_at).format("MMM Do YYYY")
    }))
  );

export const getReviewsCount = reviews => getReviews(reviews).length;

export const encodeFilters = selected =>
  encodeURIComponent(
    JSON.stringify({
      ...pick(
        [
          "title",
          "company",
          "major",
          "graduated_from",
          "group_tag",
          "city",
          "country"
        ],
        selected
      ),
      ...(selected.recommended && {
        recommended: true
      })
    })
  );

export const decodeFilters = selected => {
  const parsed = JSON.parse(decodeURIComponent(selected));
  return {
    ...pick(
      [
        "title",
        "company",
        "group_tag",
        "major",
        "graduated_from",
        "city",
        "country"
      ],
      parsed
    ),
    ...(parsed.recommended && {
      recommended: [recommendedTitle]
    })
  };
};

export const getRatingDetails = criteria =>
  criteria.map(r => ({
    criteria: r.question,
    stars: r.rate
  }));



// WEBPACK FOOTER //
// ./src/modules/insiders/model.js